import React from "react";

import { HintView, st } from "lib/index";

const Hint = ({ coop }) =>
  coop.agent.is_st ? (
    <HintView.Hint>
      <h3>{I18n.tt("papp.agents.EditAgentCooperationView.st_cooperation_hint.p1")}</h3>
      <p>{I18n.tt("papp.agents.EditAgentCooperationView.st_cooperation_hint.p2")}</p>
      <p>
        {I18n.tt("papp.agents.EditAgentCooperationView.st_cooperation_hint.p3", {
          tel: (
            <a href={`tel:${I18n.t("papp.common.st_phone_number").replace(/\s/g, "")}`}>
              {I18n.t("papp.common.st_phone_number")}
            </a>
          ),
          email: <a href={`mailto:${I18n.t("papp.common.st_email")}`}>{I18n.t("papp.common.st_email")}</a>,
        })}
      </p>
    </HintView.Hint>
  ) : (
    <HintView.Hint>
      <h3>Wskazówki</h3>
      <p>Wskazówki apropo tego widoku pojawią się tu już wkrótce.</p>
    </HintView.Hint>
  );

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/agents/EditAgentCooperationView/EditAgentCooperationHint.jsx